import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ShimmerSocialPost, ShimmerTitle } from 'react-shimmer-effects';
import axios from '../../API/axios';
import { getEmojiDDL } from '../../Services/apiService';
import { NewsFeed, post } from '../../config/imagesLink'
import PostComment from '../NewsFeed/PostComment';
import PostEngagement from '../NewsFeed/PostEngagement';
import PostInteractionModal from '../NewsFeed/PostInteractionModal'
import moment from 'moment';
import { Link } from 'react-router-dom';
import Comment from '../NewsFeed/Comment';
import ImageSliderModal from '../NewsFeed/ImageSliderModal';
import LikesDetails from '../NewsFeed/LikesDetails';
import { PostFeedSkeleton } from "@skeleton";
import PostVideoCommon from './PostVideoCommon';
import PostComponent from '../NewsFeed/PostComponent'; 
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';
import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import Advertisement from '../NewsFeed/PostAdvertisement';
import { useTranslation } from 'react-i18next';
import useNewsFeedStore from '../NewsFeed/useNewsFeedStore';
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Tooltip } from '@mui/material';

const Saved = ({ getUserProfileStat, setShowDeletePost,showDeletePost }) => {
    const sessionId = localStorage.getItem("sessionId");
    const guestModeData = localStorage.getItem("guestMode");
    const { t } = useTranslation();
    const userUid = localStorage.getItem("userUid");
    const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
    const language = localStorage.getItem("Lang");
      const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
    const [isLiked, setIsLiked] = useState(false);
  const [postLikeState, setPostLikeState] = useState({});
    //************************ All Post List  ************************//
    const [postList, setPostList] = useState([]);
    const [isLoading, setIsLoading] = useState(true)
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isError, setIsError] = useState(false);
    // const [isSavedPage, setIsSavedPage] = useState(false);
    const isSavedPage = true;
    const [initialSlideIndex, setInitialSlideIndex] = useState(0);
    const [nextBatchLoading, setNextBatchLoading] = useState(false);
    const [hasMoreData, setHasMoreData] = useState(true);
      const [isConnected, setIsConnected] = useState(false);
    
       // -------------------------------------------------------------------------
        const { setIsNewsPageLoaded } = useNewsFeedStore();
      
        useEffect(() => {
          setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed
      
          return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
        }, [setIsNewsPageLoaded]);
      
        // -------------------------------------------------------------------------
      
    // const [restrictedViewerToken, setRestrictedViewerToken] = useState('');
      const [imageArray, setImageArray] = useState([]);
    
        const [activeVideoId, setActiveVideoId] = useState(null);

    const visibleVideoRef = useRef(null)    

    const AllPostList = async (page) => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            pageNumber: page,
            pageSize: 8,
            langKey: language === "en" ? "" : language,
        }
        try {
            setNextBatchLoading(true);
            const resData = await axios.post("Posts/GetSavedPosts?SortBy=Recent", data);
        
                setIsLoading(false);
                setTotalPages(resData?.data?.responseData?.paging?.totalPages);
                    const newPosts = resData?.data?.responseData?.dataList;
                    // console.log("newPostsssssssssss", newPosts);
                     if (resData.status === 204 || !newPosts || newPosts.length === 0) {
                      setIsError(true);
                      setIsLoading(false); 
                      setHasMoreData(false);

                    } else {
                    setPostList((prev) => {
                        const postSet = new Set(prev?.map((post) => post?.postInfo?.postId));
                        const uniqueNewPosts = newPosts?.filter(
                            (post) => !postSet.has(post?.postInfo?.postId)
                        );
                        return [...prev, ...uniqueNewPosts];
                    });
                  }
                    
                    if (page >= resData.data.responseData.paging.totalPages) {
                        setHasMoreData(false);
                    }
                    setNextBatchLoading(false);
                 
        } catch (error) {
            console.log(error);
            if (error.response && error.response.status === 404) {
                setIsError(true);
            } else {
                console.error(error);
            }
            setNextBatchLoading(false);
        }
    };

    useEffect(() => {
        if (hasMoreData && totalPages >= page) {
            AllPostList(page);
        }
    }, [page]); 

    const handleInfiniteScroll = async () => {
      
        if (nextBatchLoading || !hasMoreData) return; 
        if (
            window.innerHeight + document.documentElement.scrollTop + 1 >=
            document.documentElement.scrollHeight
        ) {
            setNextBatchLoading(true); // lock until API finishes
            setPage((prev) => prev + 1);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleInfiniteScroll);
        return () => window.removeEventListener("scroll", handleInfiniteScroll);
    }, [nextBatchLoading, hasMoreData]);

        const getPostListWithAds = (posts) => {
    const result = [];
    posts.forEach((post, index) => {
        result.push(post); 
        if ((index + 1) % 8 === 0) {
        result.push({ isAd: true });
        }
    });
    return result;
       };
       const postsWithAds = getPostListWithAds(postList);


    const [showModal, setShowModal] = useState(false);
    const [postLikedType, setPostLikedType] = useState(false);
    const [postId, setPostId] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImages, setModalImages] = useState([]);
    const [singlePostContent, setSinglePostContent] = useState("");
    const [singlepostId, setSinglePostId] = useState("");
    const [ispostmodalOpen, setIspostmodalOpen] = useState(false);
    const [dLike, setDLike] = useState(0);
    const [emojiList, setemojiList] = useState();
    const openModal = (images) => {
        setIsLoading(true);

        setModalImages(images);
        setIsModalOpen(true);
    };

    const mergePostData = useCallback((existingPost, incomingPostData, incomingComments = null) => {
      if (!incomingPostData) return existingPost;

      if (incomingPostData?.postInfo) {
        return {
          ...existingPost,
          ...incomingPostData,
          postInfo: {
            ...existingPost?.postInfo,
            ...incomingPostData.postInfo,
            comments: Array.isArray(incomingComments)
              ? incomingComments
              : Array.isArray(incomingPostData?.postInfo?.comments)
                ? incomingPostData.postInfo.comments
                : existingPost?.postInfo?.comments || [],
          },
        };
      }

      return {
        ...existingPost,
        postInfo: {
          ...existingPost?.postInfo,
          ...incomingPostData,
          comments: Array.isArray(incomingComments)
            ? incomingComments
            : Array.isArray(incomingPostData?.comments)
              ? incomingPostData.comments
              : existingPost?.postInfo?.comments || [],
        },
      };
    }, []);

    const syncPostInFeed = useCallback(async (postIdToSync) => {
      if (!postIdToSync) return;

      try {
        const response = await axios.get(
          `/Posts/GetPostInfo?DeviceType=Web&PostId=${postIdToSync}&RestrictedViewerToken=${restrictedViewerTokens || ""}&langKey=${language === "en" ? "" : language}`
        );

        const latestPostData = response?.data?.responseData?.postInfo;
        if (!latestPostData) return;

        if (typeof latestPostData?.postActionsInfo?.isLiked === "boolean") {
          setPostLikeState((prev) => ({
            ...prev,
            [String(postIdToSync)]: latestPostData.postActionsInfo.isLiked,
          }));
        }

        setPostList((prevList) =>
          prevList.map((post) =>
            post?.postInfo?.postId === postIdToSync
              ? mergePostData(post, latestPostData)
              : post
          )
        );
      } catch (error) {
        console.error("Failed to sync saved post data after modal close:", error);
      }
    }, [language, restrictedViewerTokens, mergePostData]);

    const closeModal = (closePayload = singlepostId) => {
      const isPayloadObject = typeof closePayload === "object" && closePayload !== null;

      const postIdToSync = isPayloadObject
        ? closePayload?.postId ?? singlepostId
        : closePayload;

      const modalPostSnapshot = isPayloadObject ? closePayload?.postSnapshot : null;
      const modalCommentsSnapshot = isPayloadObject ? closePayload?.commentsSnapshot : null;

      setIsModalOpen(false);

      if (postIdToSync && modalPostSnapshot) {
        const modalLikedState =
          modalPostSnapshot?.postInfo?.postActionsInfo?.isLiked ??
          modalPostSnapshot?.postActionsInfo?.isLiked;

        if (typeof modalLikedState === "boolean") {
          setPostLikeState((prev) => ({
            ...prev,
            [String(postIdToSync)]: modalLikedState,
          }));
        }

        setPostList((prevList) =>
          prevList.map((post) =>
            post?.postInfo?.postId === postIdToSync
              ? mergePostData(post, modalPostSnapshot, modalCommentsSnapshot)
              : post
          )
        );
      }

      setTimeout(() => {
        syncPostInFeed(postIdToSync);
      }, 350);
    };
    const GetEmoji = async () => {
        try {
            const responseData = await getEmojiDDL(language);
            setemojiList(responseData);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        GetEmoji();
    }, []);
    const updateCommentCount = (postId, change) => {
        setPostList((prev) =>
            prev.map((post) =>
          post?.postInfo?.postId === postId
            ? {
              ...post,
              postInfo: {
                ...post.postInfo,
                commentCount: Math.max((post?.postInfo?.commentCount || 0) + change, 0),
              },
            }
            : post
            )
        );
    };
    const handleShowModal = (item) => {
        console.log(".................sttt", item);
        
        setPostId(item?.postInfo?.postId);
        setPostLikedType(item.likedType);
        setShowModal(true);
    };
    const updateLikeCount = (postId, delta, isLikedStatus, likedType) => {
        setPostList((prev) =>
            prev.map((post) =>
          post?.postInfo?.postId === postId
            ? {
              ...post,
              postInfo: {
                ...post.postInfo,
                likeCount: Math.max((post?.postInfo?.likeCount || 0) + delta, 0),
                postActionsInfo: {
                  ...post?.postInfo?.postActionsInfo,
                  ...(typeof isLikedStatus === "boolean" ? { isLiked: isLikedStatus } : {}),
                  ...(likedType !== undefined ? { likedType } : {}),
                },
              },
            }
            : post
            )
        );

      if (typeof isLikedStatus === "boolean") {
        setPostLikeState((prev) => ({
          ...prev,
          [String(postId)]: isLikedStatus,
        }));
      }
    };

    const updateShareCount = (postId, change) => {
        setPostList((prev) =>
            prev.map((post) =>
          post?.postInfo?.postId === postId
            ? {
              ...post,
              postInfo: {
                ...post.postInfo,
                shareCount: Math.max((post?.postInfo?.shareCount || 0) + change, 0),
              },
            }
            : post
            )
        );
    };

    const updatePostLike = (postId, delta, isLikedStatus, likedType) => {
        setPostList((prev) =>
            prev.map((post) => {
                if (post.postInfo.postId === postId) {
                    return {
                        ...post,
                        postInfo: {
                            ...post.postInfo,
                            postActionsInfo: {
                                ...post.postInfo.postActionsInfo,
                                isLiked: isLikedStatus,
                                likedType: likedType,
                            },
                        },
                    };
                }
                return post;
            })
        );

        if (typeof isLikedStatus === "boolean") {
            setPostLikeState((prev) => ({
                ...prev,
                [String(postId)]: isLikedStatus,
            }));
        }
    };

  const updateCommentLike = (postId, commentId, action, likeType = null) => {
    setPostList((prevPosts) =>
      prevPosts.map((post) => {
        if (post?.postInfo?.postId !== postId) return post;

        return {
          ...post,
          postInfo: {
            ...post.postInfo,
            comments: (post.postInfo.comments || []).map((comment) => {
              if ((comment.commentId ?? comment.pstCmntId) !== commentId) return comment;

              if (action === "change") {
                return {
                  ...comment,
                  isLiked: true,
                  likedType: likeType,
                };
              }

              if (action === "like") {
                return {
                  ...comment,
                  isLiked: true,
                  likedType: likeType,
                };
              }

              if (action === "unlike") {
                return {
                  ...comment,
                  isLiked: false,
                  likedType: null,
                };
              }

              return comment;
            }),
          },
        };
      })
    );
  };

  const updateReplyCommentLike = (postId, commentId, replyCommentId, action, likeType = null) => {
    setPostList((prevPosts) =>
      prevPosts.map((post) => {
        if (post?.postInfo?.postId !== postId) return post;

        return {
          ...post,
          postInfo: {
            ...post.postInfo,
            comments: (post.postInfo.comments || []).map((comment) => {
              if ((comment.commentId ?? comment.pstCmntId) !== commentId) return comment;

              return {
                ...comment,
                commentsReplies: (comment.commentsReplies || []).map((reply) => {
                  if ((reply.replyCommentId ?? reply.pstCmntRplyId) !== replyCommentId) return reply;

                  if (action === "change") {
                    return {
                      ...reply,
                      isLiked: true,
                      likedType: likeType,
                    };
                  }

                  if (action === "like") {
                    return {
                      ...reply,
                      isLiked: true,
                      likedType: likeType,
                    };
                  }

                  if (action === "unlike") {
                    return {
                      ...reply,
                      isLiked: false,
                      likedType: null,
                    };
                  }

                  return reply;
                }),
              };
            }),
          },
        };
      })
    );
  };

  const currentModalPost = postList.find(
    (post) => String(post?.postInfo?.postId) === String(singlepostId)
  );

  const modalIsLiked = Boolean(
    postLikeState[String(singlepostId)] ?? currentModalPost?.postInfo?.postActionsInfo?.isLiked
  );

  const handleModalSetIsLiked = (likedValue) => {
    const modalPostId = singlepostId || currentModalPost?.postInfo?.postId;
    if (!modalPostId) return;

    const nextLiked = Boolean(likedValue);

    setPostLikeState((prev) => ({
      ...prev,
      [String(modalPostId)]: nextLiked,
    }));

    setPostList((prevList) =>
      prevList.map((post) =>
        String(post?.postInfo?.postId) === String(modalPostId)
          ? {
            ...post,
            postInfo: {
              ...post.postInfo,
              postActionsInfo: {
                ...post?.postInfo?.postActionsInfo,
                isLiked: nextLiked,
              },
            },
          }
          : post
      )
    );
  };
    //************************ All Post List  ************************//

    const handleLikesCloseModal = () => {
        setShowModal(false);
        // setSelectedItem(null);
    };

    const [isfollowed, setIsfollowed] = useState(false);
    const addTargetBlankToAnchors = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;

        const anchors = div.querySelectorAll('a');
        anchors.forEach(anchor => {
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('rel', 'noopener noreferrer');
        });

        return div.innerHTML;
    };

    const linkifyContent = (htmlContent) => {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
        return htmlContent.replace(urlPattern, function (url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    };


    return (
        <>
        <div className="post-container">

            {isLoading ? (
                <PostFeedSkeleton count={2} />
            ) : isError || postList.length === 0? (
                <div className="mt-2 text-center">
                    <img src={post.errorSmall} alt="404 Not Found" width={200} />
                </div>
            ) : (
                   <>
                      {postsWithAds
                        ?.filter((item) => !item.isDeleted)
                        .map((item, index) => {
                    const now = moment.utc().local();
                    const itemTime = moment.utc(item?.postInfo?.creationTime).local();

                    const diffSeconds = now.diff(itemTime, "seconds");
                    const diffMinutes = now.diff(itemTime, "minutes");
                    const diffHours = now.diff(itemTime, "hours");
                    const diffDays = now.diff(itemTime, "days");

                    const diffMonths = now.diff(itemTime, "months", true);
                    const diffYears = now.diff(itemTime, "years", true);

                    let result = "";

                    /* JUST NOW */
                    if (diffSeconds < 60) {
                      result = t("Notifications.Just Now");
                    }

                    /* MINUTES */
                    else if (diffMinutes < 60) {
                      result =
                        diffMinutes === 1
                          ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                          : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                    }

                    /* HOURS */
                    else if (diffHours < 24) {
                      result =
                        diffHours === 1
                          ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                          : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                    }

                    /* DAYS */
                    else if (diffDays < 30) {
                      result =
                        diffDays === 1
                          ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                          : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                    }

                    /* MONTHS */
                    else if (diffMonths < 12) {
                      const displayMonth =
                        diffMonths >= 0.75 && diffMonths < 1.25
                          ? 1
                          : Math.round(diffMonths * 2) / 2;

                      result =
                        displayMonth === 1
                          ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                          : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                    }

                    /* YEARS */
                    else {
                      const displayYear =
                        diffYears >= 0.75 && diffYears < 1.25
                          ? 1
                          : Math.round(diffYears * 2) / 2;

                      result =
                        displayYear === 1
                          ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                          : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                    }
                          return (
                            <React.Fragment key={item?.isAd ? `ad-${index}` : `post-${item?.postInfo?.postId}`}>
                              {item.isAd && (
                                <Advertisement key={`ad-${index}`} />
                              )}
                             
        
                              {!item.isAd &&  (
                                  <div
                                    className="featured-card user-postOnlyContent p-2 mb-3"
                                    key={`post-${item?.postInfo?.postId}`}
                                  >
                                    <div className="feature-content p-2 d-flex justify-content-between">
                                      <Link to={`/User/${item?.postInfo?.userUid}`}>
                                        <div className="d-flex align-items-center">
                                          <div className="ImgAvatar">
                                            <img
                                              src={item?.postInfo?.userAvatar}
                                              alt=""
                                              style={{ borderRadius: "50px" }}
                                            />
                                          </div>
                                          <div className="ms-2">
                                            <div className="d-flex userName"> 
                                            <h4 className="f-14 fw-bold mb-0 ">
                                              {item?.postInfo?.userName}{" "}
                                            <span className="f-12 ms- fw-600" style={{color: 'rgb(58, 116, 246)'}}>{item?.postInfo?.nameTag}</span>
                                            </h4>
                                            </div>
                                            {/* <h4 className="f-14 fw-bold mb-0">
                                              {item?.postInfo?.userName}
                                            </h4> */}
                                            
                                          <div className="d-flex justify-content-start">
                                            <div>
                                              {/* <p className="f-10 label">
                                                {moment
                                                  .utc(item?.postInfo?.creationTime)
                                                  .local()
                                                  .format("DD MMMM YYYY [at] h:mm a")}
                                              </p> */}
                                                {language === "ar" ? (
                                                          <Tooltip title={moment
                                                            .utc(item?.postInfo?.creationTime)
                                                            .locale(locale)
                                                            .local()
                                                            .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                        <p className="f-10 label"> 
                                                          {moment
                                                            .utc(item?.postInfo?.creationTime)
                                                            .locale(locale)
                                                            .local()
                                                            .format("D MMMM YYYY [الساعة] h:mm a" )}
                                                        </p>
                                                     </Tooltip>
                                                  ) : (
                                                     <Tooltip title={moment
                                                            .utc(item?.postInfo?.creationTime)
                                                            .local()
                                                           .format(language === "en"
                                                                ? "D MMMM YYYY [at] h:mm a"
                                                                :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                        <p className="f-10 label"> 
                                                          {result}
                                                          {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                        </p>
                                                     </Tooltip> 
                                                      
          
                                                  )}                                
                                            </div>
                                            <div className="ms-1 d-flex align-items-center" >
                                              {item?.postInfo?.privacyType === "Public" && (
                                                <>
                                                  <PublicSharpIcon fontSize="inherit" className="f-6 label" style={{ color: '#9e9e9e' }} />
                                                </>
                                              )}
                                              {item?.postInfo?.privacyType === "Friends" && (
                                                <>
                                                  <GroupSharpIcon fontSize="small" className=" f-10 label" style={{ color: '#9e9e9e' }} />
                                                </>
                                              )}
                                              {item?.postInfo?.privacyType === "OnlyMe" && (
                                                <>
                                                  <LockSharpIcon className="f-10 label" style={{ color: '#9e9e9e' }} />
                                                </>
                                              )}
                                              {item?.postInfo?.privacyType === "Custom" && (
                                                <>
                                                  <TuneSharpIcon className="f-10 label" style={{ color: '#9e9e9e' }} />
                                                </>
                                              )}
                                            </div>
                                            <div>

                                            </div>
                                          </div>

                                        </div>
                                    </div>
                                  </Link>
                                        {
                                  guestModeData === "true" ? (
                                    ""

                                  ) : (
                                  <div className="d-flex">
                                    {item.cntntTypCategory === 'SharePost' ?
                                      (
                                        <>
                                          <span class=" me-2">
                                            <p className="badge badge-subtle badge-info1 f-12">
                                              {t("Newsfeed.Shared Post")}
                                            </p>
                                          </span>
                                        </>
                                      ) : item.cntntTypCategory === 'Article' ? (
                                        <>
                                          <span class=" me-2">
                                            <p className="badge badge-subtle badge-info1 f-12">
                                              {t("Newsfeed.Article")}
                                            </p>
                                          </span>
                                        </>
                                      ) : null}
                                    {/* <div className="row"> */}
                                    <div>
                                      <PostInteractionModal
                                        postId={item?.postInfo?.postId}
                                        AllPostList={AllPostList}
                                        postList={postList}
                                        setPage={setPage}
                                        setPostList={setPostList}
                                        page={page}
                                        setTotalPages={setTotalPages}
                                        totalPages={totalPages}
                                        setIsConnected={setIsConnected}
                                        isConnected={isConnected}
                                        item={item}
                                        PostOriginType={"User"}
                                        postOriginId={userUid}
                                        setShowDeletePost={setShowDeletePost}
                                        showDeletePost={showDeletePost}
                                        ispinned={item?.postInfo?.postActionsInfo?.isPinned}
                                        restrictedViewerToken={restrictedViewerTokens}
                                      />
                                    </div>
                                    {/* </div> */}
                                  </div>
                                )
                                }
                                      </div>
                        {/* {item?.postContent && <p className="f-14 p-2 postContent" >{item?.postContent}</p>} */}


                        {item.cntntTypCategory === 'Article' || item.contentType === 'ArticlePost' ?
                          <h4 className="f-14 fw-bold mb-0">
                            {item?.postInfo?.articleInfo?.title}</h4>
                          :
                          <>
                            <PostComponent item={item} restrictedViewerToken={restrictedViewerTokens} />
                          </>
                        }

                        <div
                          className="feed-post"
                          style={{
                            paddingTop:
                              item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                          }}
                        >
                          <div className="row">
                            {item?.cntntTypCategory !== "TextWithVideo" &&
                              item?.cntntTypCategory !== "Video" ? (
                              <>
                                {item?.postInfo?.mediaFilesList
                                  ?.slice(0, 4)
                                  .map((file, idx) => (
                                    <div
                                      key={idx}
                                      className={`col-${item?.postInfo?.mediaFilesList.length === 1
                                          ? "12"
                                          : "6"
                                        } ${item?.postInfo?.mediaFilesList.length === 3 &&
                                          idx === 0
                                          ? "col-12"
                                          : ""
                                        }`}
                                      onClick={() => {
                                        setInitialSlideIndex(idx);
                                        setImageArray(item?.postInfo?.mediaFilesList);
                                        // console.warn("===========1============>>", idx);
                                        let imageData =
                                          item?.postInfo?.mediaFilesList.map(
                                            (file) => file.mediaName
                                          );
                                        // openModal(imageData, idx);
                                        setSinglePostContent(item);
                                        setSinglePostId(item?.postInfo?.postId);

                                        if (
                                          //  item?.cntntTypCategory !== 'Video' ||
                                          //       item?.cntntTypCategory !== 'TextWithVideo'
                                          item?.cntntTypCategory === 'UserStory' ||
                                          item?.cntntTypCategory === 'TextWithImage' ||
                                          item?.cntntTypCategory === 'Text' ||
                                          item?.cntntTypCategory === 'Image'
                                        ) {
                                          openModal(imageData, idx);
                                        }
                                        if (
                                          item?.cntntTypCategory === 'Article' ||
                                          item?.contentType === 'ArticlePost'
                                        ) {
                                          window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank');
                                        }
                                      }}
                                      style={{
                                        position: "relative",
                                        cursor: "pointer",
                                        padding:
                                          item?.postInfo?.mediaFilesList.length === 3 &&
                                            idx === 0
                                            ? "0 0 5px 0"
                                            : item?.postInfo?.mediaFilesList.length ===
                                              3 && idx === 1
                                              ? "0 5px 5px 0"
                                              : item?.postInfo?.mediaFilesList.length ===
                                                4 && idx === 2
                                                ? "0 5px 0 0"
                                                : item?.postInfo?.mediaFilesList.length ===
                                                  4 && idx === 0
                                                  ? "0 5px 5px 0"
                                                  : item?.postInfo?.mediaFilesList.length ===
                                                    2 && idx === 0
                                                    ? "0 5px 5px 0"
                                                    : "",
                                      }}
                                    >
                                      {item?.cntntTypCategory !== 'TextWithVideo' &&
                                        item?.cntntTypCategory !== 'Video' ? (
                                        <img
                                          src={file?.mediaName}
                                          alt=""
                                          className="img-fluid m-auto modal-imag"
                                          width={"100%"}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = post.noimgavailable;
                                          }}
                                          style={{
                                            width: '100%',
                                            height:
                                              item?.postInfo?.mediaFilesList?.length === 1 ? 'auto' : '250px',
                                            maxHeight:
                                              item?.postInfo?.mediaFilesList?.length === 1 ? '500px' : '250px',
                                            objectFit:
                                              item?.postInfo?.mediaFilesList?.length === 1 ? 'contain' : 'cover',
                                          }}
                                        />
                                      ) : null}
                                      {idx === 3 &&
                                        item?.postInfo?.postMediaCount > 4 && (
                                          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                            +{item?.postInfo?.postMediaCount - 4}
                                          </div>
                                        )}
                                    </div>
                                  ))}
                              </>
                            ) : null}
                            {item?.cntntTypCategory === "TextWithVideo" ||
                              item?.cntntTypCategory === "Video" ? (
                              <>
                                {item?.postInfo?.mediaFilesList
                                  ?.slice(0, 4)
                                  ?.map((file, idx) => (
                                    <div
                                      key={idx}
                                      className={`col-${item?.postInfo?.mediaFilesList?.length === 1
                                          ? "12"
                                          : "6"
                                        } ${item?.postInfo?.mediaFilesList?.length === 3 &&
                                          idx === 0
                                          ? "col-12"
                                          : ""
                                        }`}
                                      onClick={() => {
                                        setInitialSlideIndex(idx);
                                        setImageArray(item?.postInfo?.mediaFilesList);
                                        let imageData =
                                          item?.postInfo?.mediaFilesList?.map(
                                            (file) => file?.mediaName
                                          );

                                        setSinglePostContent(item);
                                        setSinglePostId(item?.postInfo?.postId);
                                        // (item?.cntntTypCategory === 'UserStory' ||
                                        //    item?.cntntTypCategory === 'Text'  ||
                                        //    item.cntntTypCategory=== 'Image' ) 
                                        //    && openModal(imageData, idx);
                                        //   if (
                                        //       item?.cntntTypCategory === 'Article'  
                                        //     ) { 
                                        //     window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank'); 
                                        //     }
                                        if (
                                          //  item?.cntntTypCategory !== 'Video' ||
                                          //       item?.cntntTypCategory !== 'TextWithVideo' 
                                          item?.cntntTypCategory === 'UserStory' ||
                                          item?.cntntTypCategory === 'TextWithImage' ||
                                          item?.cntntTypCategory === 'Text' ||
                                          item?.cntntTypCategory === 'Image'
                                        ) {
                                          openModal(imageData, idx);
                                        }
                                        if (
                                          item?.cntntTypCategory === 'Article' ||
                                          item?.contentType === 'ArticlePost'
                                        ) {
                                          window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank');
                                        }
                                      }}
                                      style={{
                                        position: "relative",
                                        cursor: 'pointer',
                                        padding:
                                          item?.postInfo?.mediaFilesList.length === 3 &&
                                            idx === 0
                                            ? "0 0 5px 0"
                                            : item?.postInfo?.mediaFilesList.length ===
                                              3 && idx === 1
                                              ? "0 5px 5px 0"
                                              : item?.postInfo?.mediaFilesList.length ===
                                                4 && idx === 2
                                                ? "0 5px 0 0"
                                                : item?.postInfo?.mediaFilesList.length === 4 && idx === 0
                                                  ? "0 5px 5px 0"
                                                  : item?.postInfo?.mediaFilesList.length === 2 && idx === 0
                                                    ? "0 5px 5px 0"
                                                    : "",
                                      }}
                                    >
                                     {item?.cntntTypCategory !== 'TextWithVideo' &&
                                                                              item?.cntntTypCategory !== 'Video' ? (
                                                                              <img
                                                                                src={file?.mediaName}
                                                                                alt=""
                                                                                className="img-fluid m-auto modal-imag"
                                                                                width={"100%"}
                                                                                onError={(e) => {
                                                                                  e.target.onerror = null;
                                                                                  e.target.src = post.noimgavailable;
                                                                                
                                                                                }}
                                                                                style={{
                                                                                  width: '100%',
                                                                                  height:
                                                                                    item?.postInfo?.mediaFilesList?.length === 1 ? 'auto' : '250px',
                                                                                  maxHeight:
                                                                                    item?.postInfo?.mediaFilesList?.length === 1 ? '500px' : '250px',
                                                                                  objectFit:
                                                                                    item?.postInfo?.mediaFilesList?.length === 1 ? 'contain' : 'cover',
                                                                                }}
                                                                              />
                                                                            ) : null}
                                      <div className="newsfeed-video">

                                        {/* <iframe width="100%" height="300" src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`} frameborder="0" allowfullscreen allow="autoplay; fullscreen"
                                                  ></iframe> */}
                                        <PostVideoCommon file={file} item={item}
                                          restrictedViewerToken={restrictedViewerTokens}
                                          activeVideoId={activeVideoId}
                                          setActiveVideoId={setActiveVideoId}
                                          visibleVideoRef={visibleVideoRef} />

                                        {idx === 3 && item?.postInfo?.postMediaCount > 4 && (
                                          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                            +{item?.postInfo?.postMediaCount - 4}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                              </>) : null}


                          </div>
                          {guestModeData === "true" ? (
                            ""
                          ) : (
                            <>
                              {item.cntntTypCategory === 'Article' || item.contentType === 'ArticlePost' ? (

                                <div className="row comment-gradient-article">
                                  <PostComponent item={item}
                                    restrictedViewerToken={restrictedViewerTokens} />
                                  <div className="addComment">
                                    <PostComment
                                      item={item}
                                      postId={item?.postInfo?.postId}
                                      AllPostList={AllPostList}
                                      postList={postList}
                                      setPage={setPage}
                                      setPostList={setPostList}
                                      page={page}
                                      setTotalPages={setTotalPages}
                                      totalPages={totalPages}
                                      updateCommentCount={updateCommentCount}
                                      ispostmodalOpen={ispostmodalOpen}
                                      setIspostmodalOpen={setIspostmodalOpen}
                                    />
                                  </div>
                                </div>
                              )
                                : (
                                  <>
                                    <div className="row comment-gradient">
                                      <div className="addComment">
                                        <PostComment
                                          item={item}
                                          postId={item?.postInfo?.postId}
                                          AllPostList={AllPostList}
                                          postList={postList}
                                          setPage={setPage}
                                          setPostList={setPostList}
                                          page={page}
                                          setTotalPages={setTotalPages}
                                          totalPages={totalPages}
                                          updateCommentCount={updateCommentCount}
                                          ispostmodalOpen={ispostmodalOpen}
                                          setIspostmodalOpen={setIspostmodalOpen}
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                            </>

                          )}
                        </div>

                        <div
                          className={`postData d-flex align-items-center ${item?.postInfo?.likeCount === 0 &&
                            item?.postInfo?.commentCount === 0 &&
                            item?.postInfo?.shareCount === 0
                            ? ""
                            : "border-custom1"
                            }`}
                        >
                          <div className="ms-2">
                            {item?.postInfo?.likeCount === 0 || item?.postInfo?.likeCount === null ? (
                              ""
                            ) : (
                              <p
                                className="f-10 like-details"
                                onClick={() => handleShowModal(item)}
                              >
                                {item?.postInfo?.likeCount + dLike} <ThumbUpOutlinedIcon  style={{color:"#00419f", fontSize: "13px"}}/>
                                                      
                                {/* {t("Newsfeed.Like")}  */}
                              </p>
                            )}
                          </div>
                          <div className="ms-auto d-flex">
                            {item?.postInfo?.commentCount === 0 ? (
                              ""
                            ) : (
                              <p
                                className="f-10 me-2 pointer"
                                onClick={() => {
                                  openModal(
                                    item?.postInfo?.mediaFilesList.map(
                                      (file) => file.mediaName
                                    )
                                  );
                                  setSinglePostContent(item);
                                  setSinglePostId(item?.postInfo?.postId);
                                }}
                              >
                                {" "}
                                {item?.postInfo?.commentCount} <ChatOutlinedIcon 
                                 style={{color:"#00419f",fontSize: "13px" }}/>
                                {/* {t("Newsfeed.Comment")} */}
                              </p>
                            )}

                             
                                <p className="f-10">
                                   {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                     ? ""
                                     : `&  ${item?.postInfo?.shareCount}`} {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                     ? ""
                                     : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "13px"}} />
                                      }
                                 </p>                           
                          </div>
                        </div>

                        <div className="postengagement mb-1">
                          <PostEngagement
                            setIsLiked={(value) => {
                              const nextLiked = Boolean(value);
                              setPostLikeState((prev) => ({
                                ...prev,
                                [String(item?.postInfo?.postId)]: nextLiked,
                              }));
                            }}
                            isLiked={Boolean(
                              postLikeState[String(item?.postInfo?.postId)] ?? item?.postInfo?.postActionsInfo?.isLiked
                            )}
                            item={item}
                            postId={item?.postInfo?.postId}
                            AllPostList={getUserProfileStat}
                            isSavedPage={isSavedPage}
                            postList={postList}
                            setPage={setPage}
                            setPostList={setPostList}
                            page={page}
                            setTotalPages={setTotalPages}
                            totalPages={totalPages}
                            updateLikeCount={updateLikeCount}
                            updateShareCount={updateShareCount}
                            openModal={openModal}
                            setSinglePostContent={setSinglePostContent}
                            setSinglePostId={setSinglePostId}
                            ispostmodalOpen={ispostmodalOpen}
                            setIspostmodalOpen={setIspostmodalOpen}
                            emojiList={emojiList}
                            restrictedViewerToken={restrictedViewerTokens}
                            updatePostLike={updatePostLike}

                          />
                        </div>

                        <Comment
                          item={item}
                          isOwnedPost={item?.postInfo?.isOwned}
                          postId={item?.postInfo?.postId}
                          AllPostList={AllPostList}
                          postList={postList}
                          setPage={setPage}
                          setPostList={setPostList}
                          page={page}
                          setTotalPages={setTotalPages}
                          totalPages={totalPages}
                          emojiList={emojiList}
                          setSinglePostContent={setSinglePostContent}
                          openModal={openModal}
                          setImageArray={setImageArray}
                          setInitialSlideIndex={setInitialSlideIndex}
                          setSinglePostId={setSinglePostId}
                            updateLikeCount={updateLikeCount}
                            updateCommentLike={updateCommentLike}


                        />
                                  </div>
                                )}
                            </React.Fragment>
                          );
                        })}
                </>
                //  postList?.map((item, index) => { 
                //     return (
                //         <>
                //             <div
                //                 className="featured-card user-postOnlyContent p-2 mb-3"
                //                 key={index}
                //             >
                //                 <div className="feature-content p-2 d-flex justify-content-between">
                //                     <Link to={`/User/${item?.postInfo?.userUid}`}>
                //                         <div className="d-flex align-items-center">
                //                             <div className="ImgAvatar">
                //                                 <img
                //                                     src={item?.postInfo?.userAvatar}
                //                                     alt=""
                //                                     style={{ borderRadius: "50px" }}
                //                                 />
                //                             </div>
                //                             <div className="ms-2">
                //                                 <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName}</h4>
                //                                 <p className="f-12">{item?.postInfo?.title}</p>
                //                                 <p className="f-12">{item?.postInfo?.additionalInfo}</p>
                //                                 <p className="f-12">
                //                                     {/* {moment(item.creationTime).format(
                //                                         "MMMM Do YYYY, h:mm:ss a"
                //                                     )} */}
                //                                     {moment
                //                                         .utc(item?.postInfo?.creationTime)
                //                                         .local()
                //                                         .format("DD MMMM YYYY[at] h:mm a")}
                //                                 </p>
                //                             </div>
                //                         </div>
                //                     </Link>

                //                     {guestModeData === "true" ? (
                //                         ""
                //                     ) : (
                //                         <div className="row">
                //                             <div>
                //                                 <PostInteractionModal
                //                                     postId={item?.postInfo?.postId}
                //                                     AllPostList={AllPostList}
                //                                     postList={postList}
                //                                     setPage={setPage}
                //                                     setPostList={setPostList}
                //                                     page={page}
                //                                     restrictedViewerToken={restrictedViewerToken}
                //                                     setTotalPages={setTotalPages}
                //                                     totalPages={totalPages}
                //                                     item={item}
                //                                     PostOriginType={"User"}
                //                                     postOriginId={userUid}
                //                                     isfollowed={isfollowed}
                //                                     setIsfollowed={setIsfollowed}
                //                                     ispinned={item?.postInfo?.postActionsInfo?.isPinned}
                //                                 />
                //                             </div>
                //                         </div>
                //                     )}
                //                 </div>
                               
                //                   {item.cntntTypCategory==='Article' || item.contentType==='ArticlePost' ? 
                //                       <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.articleInfo?.title}</h4>
                //                           : 
                //                          <>
                //                          <PostComponent item={item} />
                //                          </>
                //                      }
                //                 <div
                //                     className="feed-post"
                //                     style={{
                //                         paddingTop: item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                //                     }}
                //                 >
                //                     <div className="row">  
                //                         {item?.postInfo?.mediaFilesList?.map((file, idx) => (
                //                             <div
                //                                 key={idx}
                //                                 className={`col-${item?.postInfo?.mediaFilesList.length === 1 ? "12" : "6"
                //                                     } ${item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                //                                         ? "col-12"
                //                                         : ""
                //                                     }`}
                //                                 // onClick={() => {
                //                                 //     setInitialSlideIndex(idx); 
                //                                 //      const mediaList = item?.postInfo?.mediaFilesList || [];

                //                                 //     const imageData = mediaList.map((file) => file.mediaName);
                //                                 //     setImageArray(mediaList);
                //                                 //     setSinglePostContent(item);
                //                                 //     setSinglePostId(item?.postInfo?.postId);
                //                                 //     // (item?.cntntTypCategory === 'UserStory' || item?.cntntTypCategory === 'Text' 
                //                                 //     // || item.cntntTypCategory=== 'Image'  ) 
                //                                 //     // &&   openModal(
                //                                 //     //                 item?.postInfo?.mediaFilesList?.map((file) => file.mediaName)
                //                                 //     //             );
                //                                 //     if (
                //                                 //     // item?.cntntTypCategory !== 'Video' ||
                //                                 //     // item?.cntntTypCategory !== 'TextWithVideo'
                //                                 //     item?.cntntTypCategory === 'UserStory' ||
                //                                 //     item?.cntntTypCategory === 'Text' ||
                //                                 //     item?.cntntTypCategory === 'TextWithImage' ||
                //                                 //     item?.cntntTypCategory === 'Image'
                //                                 //     ) { 
                //                                 //     openModal(imageData, idx);
                //                                 //     }
                //                                 //     if (
                //                                 //         item?.cntntTypCategory === 'Article' ||
                //                                 //         item?.contentType === 'Post'
                //                                 //     ) { 
                //                                 //         window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank'); 
                //                                 //     }
                //                                 // }}
                //                                  onClick={() => {
                //                             console.log("Clicked item:", item);

                //                             setInitialSlideIndex(idx);
                //                             const mediaList = item?.postInfo?.mediaFilesList || [];

                //                             const imageData = mediaList.map((file) => file.mediaName);
                //                             setImageArray(mediaList);
                //                             setSinglePostContent(item);
                //                             setSinglePostId(item?.postInfo?.postId);

                //                             if (
                //                               // item?.cntntTypCategory !== 'Video' ||
                //                               // item?.cntntTypCategory !== 'TextWithVideo'
                //                               item?.cntntTypCategory === 'UserStory' ||
                //                               item?.cntntTypCategory === 'Text' ||
                //                               item?.cntntTypCategory === 'TextWithImage' ||
                //                               item?.cntntTypCategory === 'Image'
                //                             ) {
                //                               console.log("Opening modal with:", imageData, idx);
                //                               openModal(imageData, idx);
                //                             }

                //                             if (
                //                               item?.cntntTypCategory === 'Article' ||
                //                               item?.contentType === 'ArticlePost'
                //                             ) {
                //                               window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank');
                                             
                //                             }
                //                           }}
                //                                 style={{
                //                                     position: "relative",
                //                                     cursor:'pointer',
                //                                     padding:
                //                                         item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                //                                             ? "0 0 5px 0"
                //                                             : item?.postInfo?.mediaFilesList.length === 3 && idx === 1
                //                                                 ? "0 5px 5px 0"
                //                                                 : item?.postInfo?.mediaFilesList.length === 4 && idx === 2
                //                                                     ? "0 5px 0 0"
                //                                                     : item?.postInfo?.mediaFilesList.length === 4 && idx === 0
                //                                                         ? "0 5px 5px 0"
                //                                                         : item?.postInfo?.mediaFilesList.length === 2 && idx === 0
                //                                                             ? "0 5px 5px 0"
                //                                                             : "",
                //                                 }} >

                //                               {item?.cntntTypCategory !== 'TextWithVideo' || item?.cntntTypCategory !== 'Video' ? 
                //                                 <img
                //                                    src={file?.mediaName}
                //                                     alt=""
                //                                                     className="img-fluid"
                //                                                     width={"100%"}
                //                                                     /> : null}
                //                                                     {item?.cntntTypCategory === 'TextWithVideo' || item?.cntntTypCategory === 'Video' ?
                //                                                      <div className="newsfeed-video">

                //                                                     <PostVideoCommon 
                //                                                     file={file} 
                //                                                     item={item} 
                //                                                     restrictedViewerToken={restrictedViewerToken} 
                //                                                     setActiveVideoId={setActiveVideoId}  
                //                                                     activeVideoId={activeVideoId} 
                //                                                     visibleVideoRef={visibleVideoRef}
                //                                                     />

                //                                                     {/* <iframe width="100%" height="300" 
                //                                                     src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`} frameborder="0" allowfullscreen allow="autoplay; fullscreen"
                //                                                     ></iframe> */}
                //                                                     </div> : null}

                //                                 {idx === 3 && item?.postInfo?.postMediaCount > 4 && (
                //                                     <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                //                                         +{item?.postInfo?.postMediaCount - 4}
                //                                     </div>
                //                                 )}
                //                             </div>
                //                         ))}
                //                     </div>
                //                     {guestModeData === "true" ? (
                //                         ""
                //                     ) : (
                //                         // <div className="row comment-gradient">
                //                         //     <div
                //                         //         className="addComment"
                //                         //         onClick={() => {
                //                         //             openModal(
                //                         //                 item?.postInfo?.mediaFilesList?.map((file) => file.mediaName)
                //                         //             );
                //                         //             setSinglePostContent(item);
                //                         //             setSinglePostId(item?.postInfo?.postId);
                //                         //         }}
                //                         //     >
                //                         //         <div
                //                         //             className="postCommentWrapper"
                //                         //             onClick={(event) => event.stopPropagation()}
                //                         //         >
                //                         //             <PostComment
                //                         //                 item={item}
                //                         //                 postId={item?.postInfo?.postId}
                //                         //                 AllPostList={AllPostList}
                //                         //                 postList={postList}
                //                         //                 setPage={setPage}
                //                         //                 setPostList={setPostList}
                //                         //                 page={page}
                //                         //                 setTotalPages={setTotalPages}
                //                         //                 totalPages={totalPages}
                //                         //                 updateCommentCount={updateCommentCount}
                //                         //                 ispostmodalOpen={ispostmodalOpen}
                //                         //                 setIspostmodalOpen={setIspostmodalOpen}
                //                         //             />
                //                         //         </div>
                //                         //     </div>
                //                         // </div>
                //                           <>                      
                //                            {item.cntntTypCategory==='Article' ? 
                                                                     
                //                            <div className="row comment-gradient-article">
                //                              {/* <PostComponent item={item} />   */}
                //                             <div
                //                                 className="addComment"
                //                                 onClick={() => {
                //                                     openModal(
                //                                         item?.postInfo?.mediaFilesList?.map((file) => file.mediaName)
                //                                     );
                //                                     setSinglePostContent(item);
                //                                     setSinglePostId(item?.postInfo?.postId);
                //                                 }}
                //                             >
                //                                 <div
                //                                     className="postCommentWrapper"
                //                                     onClick={(event) => event.stopPropagation()}
                //                                 >
                //                                     <PostComment
                //                                         item={item}
                //                                         postId={item?.postInfo?.postId}
                //                                         AllPostList={AllPostList}
                //                                         postList={postList}
                //                                         setPage={setPage}
                //                                         setPostList={setPostList}
                //                                         page={page}
                //                                         setTotalPages={setTotalPages}
                //                                         totalPages={totalPages}
                //                                         updateCommentCount={updateCommentCount}
                //                                         ispostmodalOpen={ispostmodalOpen}
                //                                         setIspostmodalOpen={setIspostmodalOpen}
                //                                     />
                //                                 </div>
                //                             </div>
                //                            </div>
                //                                                           : (
                //                              <div className="row comment-gradient">
                //                             <div
                //                                 className="addComment"
                //                                 onClick={() => {
                //                                     openModal(
                //                                         item?.postInfo?.mediaFilesList?.map((file) => file.mediaName)
                //                                     );
                //                                     setSinglePostContent(item);
                //                                     setSinglePostId(item?.postInfo?.postId);
                //                                 }}
                //                             >
                //                                 <div
                //                                     className="postCommentWrapper"
                //                                     onClick={(event) => event.stopPropagation()}
                //                                 >
                //                                     <PostComment
                //                                         item={item}
                //                                         postId={item?.postInfo?.postId}
                //                                         AllPostList={AllPostList}
                //                                         postList={postList}
                //                                         setPage={setPage}
                //                                         setPostList={setPostList}
                //                                         page={page}
                //                                         setTotalPages={setTotalPages}
                //                                         totalPages={totalPages}
                //                                         updateCommentCount={updateCommentCount}
                //                                         ispostmodalOpen={ispostmodalOpen}
                //                                         setIspostmodalOpen={setIspostmodalOpen}
                //                                     />
                //                                 </div>
                //                             </div>
                //                        </div>
                //                         )}
                //                         </>
                //                     )}
                //                 </div>
                //                 <div className={`postData d-flex align-items-center ${item?.postInfo?.likeCount === 0 && item?.postInfo?.commentCount === 0 && item?.postInfo?.shareCount === 0
                //                     ? ""
                //                     : "border-custom1"
                //                     }`}>
                //                     <div className="ms-2">
                //                         <p
                //                             className="f-10 like-details"
                //                             onClick={() => handleShowModal(item)}
                //                         >
                //                             {item?.postInfo?.likeCount + dLike} likes
                //                         </p>
                //                     </div>
                //                     <div className="ms-auto d-flex">
                //                         <p
                //                             className="f-10 me-2 pointer"
                //                             onClick={() => {
                //                                 openModal(
                //                                     item?.postInfo?.mediaFilesList.map((file) => file.mediaName)
                //                                 );
                //                                 setSinglePostContent(item);
                //                                 setSinglePostId(item?.postInfo?.postId);
                //                             }}
                //                         >
                //                             {" "}
                //                             {item?.postInfo?.commentCount} comments{" "}
                //                         </p>
                //                         <p className="f-10">
                //                             {item?.postInfo?.shareCount === 0
                //                                 ? ""
                //                                 : `&  ${item?.postInfo?.shareCount} Shares`}
                //                         </p>
                //                     </div>
                //                 </div>
                //                 <div className="postengagement mb-3">
                //                     <PostEngagement
                //                         item={item}
                //                         postId={item?.postInfo?.postId}
                //                         AllPostList={AllPostList}
                //                         postList={postList}
                //                         setPage={setPage}
                //                         setPostList={setPostList}
                //                         page={page}
                //                         setTotalPages={setTotalPages}
                //                         totalPages={totalPages}
                //                         updateLikeCount={updateLikeCount}
                //                         updateShareCount={updateShareCount}
                //                         openModal={openModal}
                //                         setSinglePostContent={setSinglePostContent}
                //                         setSinglePostId={setSinglePostId}
                //                         ispostmodalOpen={ispostmodalOpen}
                //                         setIspostmodalOpen={setIspostmodalOpen}
                //                         emojiList={emojiList}
                //                         isSavedPage={isSavedPage}
                //                     />
                //                 </div>
                //                 <Comment
                //                     item={item}
                //                     isOwnedPost={item?.postInfo?.isOwned}
                //                     postId={item?.postInfo?.postId}
                //                     AllPostList={AllPostList}
                //                     postList={postList}
                //                     setPage={setPage}
                //                     setPostList={setPostList}
                //                     page={page}
                //                     setTotalPages={setTotalPages}
                //                     totalPages={totalPages}
                //                     emojiList={emojiList}
                //                 />
                //             </div>
                //         </>
                //     )
                // })
            )}
        </div>    
            {(page > 1 && !hasMoreData) &&(
                <p className="text-center">{t("Newsfeed.No more data available")}</p >
            )}
            {
                nextBatchLoading && !isLoading && (
                    <div className="text-center mb-4">
                        <img src={post?.loader} width={50} />
                    </div>
                )
            }

            {isModalOpen && (
                <ImageSliderModal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    images={modalImages}
                    item={singlePostContent}
                    singlepostId={singlepostId}
                    setSinglePostId={setSinglePostId}
                    updateShareCount={updateShareCount}
                    updateLikeCount={updateLikeCount}
                    totalPages={totalPages}
                    setTotalPages={setTotalPages}
                    page={page}
                    setPostList={setPostList}
                    setPage={setPage}
                    postList={postList}
                    AllPostList={AllPostList}
                    PostEngagement={PostEngagement}
                    dLike={dLike}
                    updateCommentCount={updateCommentCount}
                    ispostmodalOpen={ispostmodalOpen}
                    setIspostmodalOpen={setIspostmodalOpen}
                    openModal={openModal}
                    setSinglePostContent={setSinglePostContent}
                    setDLike={setDLike}
                    setShowModal={showModal}
                    handleLikesCloseModal={handleLikesCloseModal}
                    initialSlideIndex={initialSlideIndex}
                    setInitialSlideIndex={setInitialSlideIndex}
                    restrictedViewerToken={restrictedViewerTokens}
                    imageArray={imageArray}
                    updateCommentLike={updateCommentLike}
                    updatePostLike={updatePostLike}
                    updateReplyCommentLike={updateReplyCommentLike}
                    isLiked={modalIsLiked}
                    setIsLiked={handleModalSetIsLiked}


                />
            )}
            {/* {showModal &&  */}
            <LikesDetails
                showModal={showModal}
                handleLikesCloseModal={handleLikesCloseModal}
                postId={postId}
                postLikedType={postLikedType}
            />
            {/* } */}

        </>
    )
}

export default Saved